import { StyleSheet } from 'aphrodite';
import { background, navigation, titles } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	infoField: {
		':not(:last-child)': {
			marginBottom: 20,
		},
		marginBottom: 0,
	},
	infoFieldContainer: {
		marginBottom: 20,
	},
	infoFieldEditing: {
		marginBottom: 35,
	},
	infoFieldLabel: {
		alignItems: 'center',
		color: navigation,
		display: 'flex',
		fontSize: 12,
		height: 17,
	},
	infoFieldValue: {
		color: titles,
		fontSize: 14,
	},
	infoIcon: {
		marginLeft: 4,
		marginTop: 5,
	},
	infoMessage: {
		background,
		color: titles,
		fontSize: 12,
		maxWidth: 500,
		whiteSpace: 'normal',
		wordWrap: 'break-word',
	},
	popover: {
		maxWidth: 300,
	},
});
